import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosConstants from "./axiosConstants";

const settings = {
  headers: {
    // "X-Interswitch-Authorization-Domain": "ISW",
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "X-XSRF-TOKEN": axiosConstants.XSRF
  }
};

interface AxiosInstanceType {
  get: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
  post: (
    url: string,
    data?: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  put: (
    url: string,
    data: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  patch: (
    url: string,
    data: any,
    request?: AxiosRequestConfig
  ) => Promise<AxiosResponse>;
  delete: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
}

const getAxiosInstance = (
  _instance: AxiosInstance,
  getAdditionalHeaders?: () => Record<string, string>
) => {
  return {
    async get(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.get(url, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async post(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        console.log(data);
        const response = await _instance.post(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async put(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.put(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async patch(url: string, data: any, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.patch(url, data, {
          ...(config || {}),
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete(url: string, config?: AxiosRequestConfig) {
      try {
        const response = await _instance.delete(url, {
          ...config,
          headers: {
            ...(getAdditionalHeaders?.() || {}),
            ...(config?.headers || {})
          }
        });
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  };
};

const baseURL =
  process.env.NODE_ENV === "production"
    ? "/mc-acquirer-abu-mandate-portlet"
    : "https://automated-billing-updater.k8.isw.la/api";
const instance = axios.create({ baseURL, ...settings });

if (process.env.NODE_ENV !== "production") {
  instance.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TmFtZSI6IklmZWFueWktT2tvcm9ua3dvIiwiZmlyc3RMb2dpbiI6ZmFsc2UsInVzZXJfbmFtZSI6IlRvY2hpLk9rb3Jvbmt3byIsIm1vYmlsZU5vIjoiMjM0ODEzMzIxMzE5OCIsImNsaWVudF9pZCI6InBvc3RtYW4iLCJmaXJzdE5hbWUiOiJUb2NoaSIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJpbmNvZ25pdG8iLCJjYWVzYXIiLCJ0cmFuc2Zlci1zZXJ2aWNlLWNvcmUiLCJpc3ctcGF5bWVudGdhdGV3YXkiLCJ0cmFuc2Zlci1zZXJ2aWNlLXBvcnRsZXQiLCJwYXNzcG9ydCIsImlzdy1wb3N0LW9mZmljZSIsImlzdy1jb2xsZWN0aW9ucyIsInZhdWx0IiwiaXN3LWNvcmUiLCJpc3ctcG9ydGFsIiwib3BzLWNlbnRyYWwiLCJpc3ctcGFwc3MiLCJ3YWxsZXQiLCJyZWN1cnJlbnQtYmlsbGluZy1hcGkiLCJoaW1zLXBvcnRsZXQiLCJ0cy1uYW1lLWVucXVpcnkiLCJuaWJzcy1pZHJpcy1jb3B5LXNldHRpbmdzIiwiY2FyZGxlc3Mtc2VydmljZSIsInBvc3RjYXJkLWFwaSIsImFyYml0ZXIiLCJyZWZlcnJhbC1zZXJ2aWNlLWFwaSIsInByb2plY3QteC1tZXJjaGFudCIsInRyYW5zZmVyLXNlcnZpY2UtYWRtaW4iLCJ3ZWJwYXktcG9ydGxldCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJpc3ctbGVuZGluZy1zZXJ2aWNlIl0sImF1dGhlbnRpY2F0ZWRCeSI6IkxEQVAiLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MzMyMDczNjA2NSwibW9iaWxlTm9WZXJpZmllZCI6dHJ1ZSwiY2xpZW50X25hbWUiOiJQb3N0bWFuIiwianRpIjoiMjM4MWM5ZTQtZjRjYy00Y2U3LTk1ODEtNjY4ZmQxZTI0ODMyIiwiZW1haWwiOiJUb2NoaS5JZmVhbnlpLU9rb3Jvbmt3b0BpbnRlcnN3aXRjaGdyb3VwLmNvbSIsInBhc3Nwb3J0SWQiOiIyOEMwNDlEMy1FQ0IzLTM4Q0MtQTUxOC04OUYyQUU4RTBDQjQifQ.FIeLy7scSV7W6-IUijqSphhWNSBkhqnfRA-0UwvRs2h_dGsN5gDZAZ7tTwok-RLWNNUBZO18c9dpCH4x7jRLytxSaIvNjkJuheYOlldEbWIxc6wY3y24zekMy4eVFO2snDcz_e6OOLBtRROOYINl7OGcc1hSpblF0cgbGi-B_fzFMZX2l2xpaZvkejOfT1Hp7Q6Rl6dEFY0Chq7oudwR5zPkcYPC3VlFeOa41iXDv4jDMbSS5v-OSBPiPEa8cXFVCmYLcZ_sFlp0LjFl-ZkFK_V-KrmlYI4ShVPHktLW2RN1hz0uDIelM8w8ax9Rkpo0Eh43D3v8FP_1-doG0AmYqQ";
}
export const axiosInstance: AxiosInstanceType = getAxiosInstance(instance);
